export const FETCH_VA_RATES_REQUEST = 'FETCH_VA_RATES_REQUEST';
export const FETCH_VA_RATES_SUCCESS = 'FETCH_VA_RATES_SUCCESS';
export const FETCH_VA_RATES_FAILURE = 'FETCH_VA_RATES_FAILURE';
export const FETCH_VA_EXCHANGERS_LIST_REQUEST =
  'FETCH_VA_EXCHANGERS_LIST_REQUEST';
export const FETCH_VA_EXCHANGERS_LIST_FAILURE =
  'FETCH_VA_EXCHANGERS_LIST_FAILURE';
export const FETCH_VA_EXCHANGERS_LIST_SUCCESS =
  'FETCH_VA_EXCHANGERS_LIST_SUCCESS';
